<template>
  <div class="">
    <top-header :type="6" :placeholder="'点评'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <div class="top_con m_flex_box flex_vc" v-if="obj">
      <img v-lazy="imgPath + 'sImgMin/' + obj.xmfm + '.jpg'"  alt="">
      <div class="info_con">
        <h4>{{obj.tgmc}}</h4>
        <div class="m_flex_box flex_vc">
          <p>
            <span>{{obj.zScore}}</span>分
          </p>
          <div class="score_con m_flex_box">
            <img src="@/assets/img/star.png" alt="" v-for="item in obj.zScore" :key="item">
            <img src="@/assets/img/star_.png" v-for="item in (5 - obj ? obj.zScore : 0)" :key="item + '_'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="score_main">
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>综合评定</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(0, item)" v-for="(item) in zScore" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(0, zScore + item)" v-for="(item) in ( 5 - zScore)" :key="'#' + item">
          </div>
        </div>
        <i>{{zScore}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>企业信誉</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(1,item)" v-for="(item) in score1" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(1,score1 + item)" v-for="(item) in ( 5 - score1)" :key="'#' + item">
          </div>
        </div>
        <i>{{score1}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>项目品质</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(2, item)" v-for="(item) in score2" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(2, score2 + item)" v-for="(item) in ( 5 - score2)" :key="'#' + item">
          </div>
        </div>
        <i>{{score2}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>楼盘质量</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(3, item)" v-for="(item) in score3" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(3, score3 + item)" v-for="(item) in ( 5 - score3)" :key="'#' + item">
          </div>
        </div>
        <i>{{score3}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>服务态度</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(4, item)" v-for="(item) in score4" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(4, score4 + item)" v-for="(item) in ( 5 - score4)" :key="'#' + item">
          </div>
        </div>
        <i>{{score4}}分</i>
      </div>
    </div>
    <div class="text_con">
      <van-field
        v-model="comment"
        rows="4"
        type="textarea"
        maxlength="500"
        placeholder="关于这个楼盘有什么要评价的......"
        show-word-limit
      />
    </div>
    <div class="pic_con">
      <van-uploader v-model="fileList" :before-read="beforeRead" :max-count="4" />
    </div>
    <div class="btn_con">
      <div class="button" @click="submit">提交</div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
export default {
  data() {
    return {
      comment: '',
      fileList: [],
      image1: '',
      image2: '',
      image3: '',
      image4: '',
      zScore: 0,
      score1: 0,
      score2: 0,
      score3: 0,
      score4: 0,
      flag: true,
      itemId: this.$route.query.itemId,
      obj: null,
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    //获取项目详情
    getDetail() {
      this.$new.post('itemInfo/getItemById.do', qs.stringify({
        id: this.itemId
      })).then(res => {
        this.obj = res.obj
      });
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 5000 * 1024) {
        this.$toast('文件大小不得超过5M');
        return false;
      }
      return true;
    },
    setScore(type, score) {
      if(type) {
        this['score' + type] = score
      } else {
        this.zScore = score
      }
    },
    submit() {
      if(!this.zScore) {
        this.$toast('请对综合评定进行评分')
        return;
      } else if (!this.score1) {
        this.$toast('请对企业信誉进行评分')
        return;
      } else if (!this.score2) {
        this.$toast('请对项目品质进行评分')
        return;
      } else if (!this.score3) {
        this.$toast('请对楼盘质量进行评分')
        return;
      } else if (!this.score4) {
        this.$toast('请对服务态度进行评分')
        return;
      } else if (!this.comment) {
        this.$toast('请输入点评')
        return;
      }
      if(!this.flag) {
        return
      } this.flag = false
      const formData = new FormData();
      this.fileList.forEach((item ,index) => {
        formData.append("image" + (index + 1), item.file);
      });
      formData.append("zScore", this.zScore);
      formData.append("score1", this.score1);
      formData.append("score2", this.score2);
      formData.append("score3", this.score3);
      formData.append("score4", this.score4);
      formData.append("comment", this.comment);
      formData.append("itemId", this.itemId);
      this.$http({
        url: 'cms/xzhouse/reg/addComment.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application'
        },
        data: formData
      }).then(res => {
        var path = this.$route.query.path;
        this.flag = true
        if(res.success) {
          this.$dialog.alert({
            title: '提示',
            message: '评论成功'
          }).then(res => {
            if(path!=='undefined'){
              this.$router.replace(path);
            }
          })
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.msg
          })
        }
      }).catch(() => {
        this.flag = true
      })
    }
  },

};
</script>
<style lang="less" scoped>
  .top_con{
    width: 7.04rem;
    margin: 0 auto;
    border-bottom: 1px solid #f5f5f5;
    padding: 0.3rem 0;
    >img{
      width: 1.52rem;
      height: 1.14rem;
      margin-right: 0.35rem;
    }
    .info_con{
      width: 5rem;
      h4{
        font-size: 0.3rem;
        height: 0.7rem;
      }
      p{
        color: #FF2A2A;
        font-size: 0.22rem;
        span{
          font-weight: 800;
          font-size: 0.32rem;
        }
      }
      .score_con{
        margin-top: 0.02rem;
        img{
          width: 0.26rem;
          height: 0.26rem;
          margin-left: 0.08rem;
          display: block;
        }
      }
    }
  }
  .score_main{
    width: 7.04rem;
    margin: 0 auto;
    padding: 0.46rem 0;
    .inner{
      margin-bottom: 0.24rem;
      &:last-child{
        margin-bottom: 0;
      }
      .left{
        font-size: 0.28rem;
        color: #909090;
        span{
          margin-right: 0.28rem;
        }
        img{
          margin-right: 0.18rem;
        }
      }
      i{
        font-size: 0.28rem;
        color: #FF2A2A;
        padding-right: 0.42rem;
      }
    }
  }
  .text_con{
    width: 7.04rem;
    margin: 0 auto;
    border: 1px solid #f5f5f5
  }
  .pic_con{
    width: 7.04rem;
    margin: 0rem auto 0.6rem;
    padding: 0.3rem 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .btn_con{
    padding-bottom: 0.4rem;
  }
  .button{
    background-color: #2F72F5;
    color: #fff;
    border-radius: 0.08rem;
    text-align: center;
    line-height: 0.74rem;
    width: 7.04rem;
    margin: 0 auto;
    font-size: 0.28rem;
  }
</style>